export default __webpack_public_path__ + "static/privacy-27d9006fa07f9628e054d81d34608102.pdf";